// Global packages and components
import { useSanityImages } from '~/hooks'

// Types
import type { SanityRefWithAlt } from '~/types'
import { SchemaElement, SchemaMeta, SchemaWrapper } from '../global'

interface Props {
  image: SanityRefWithAlt
  customSize?: number
  imageSize?: 'full' | 'half' | 'small'
  className?: string
  asImageObject?: boolean
  canonicalUrl?: string
}

const Image = ({
  image,
  customSize,
  imageSize = 'full',
  className,
  asImageObject = false,
  canonicalUrl,
}: Props) => {
  const { urlFor } = useSanityImages()

  if (!image) return null

  // Breakpoint sizes
  const sizeContainer = 1440
  const sizeHalfContainer = sizeContainer / 2

  // Size we will use
  const sizeToUse =
    customSize ?? (imageSize === 'half' ? sizeHalfContainer : sizeContainer)

  const imageUrl = urlFor(image).width(sizeToUse).auto('format').url()

  if (!asImageObject) {
    return (
      <img
        className={className ?? 'block w-full'}
        src={imageUrl}
        alt={image?.alt ?? ''}
        width={sizeToUse}
        height="auto"
        loading="lazy"
      />
    )
  }
  return (
    <SchemaWrapper
      as="span"
      className="contents"
      prop="image"
      type="ImageObject"
    >
      {image?.alt && (
        <SchemaMeta
          prop="name"
          content={image.alt}
        />
      )}
      {image?.alt && (
        <SchemaMeta
          prop="caption"
          content={image.alt}
        />
      )}
      <SchemaMeta
        prop="contentUrl"
        content={imageUrl}
      />
      {canonicalUrl && (
        <SchemaElement
          as="link"
          prop="url"
          href={canonicalUrl}
        />
      )}

      <img
        className={className ?? 'block w-full'}
        src={imageUrl}
        alt={image?.alt ?? ''}
        width={sizeToUse}
        height="auto"
        loading="lazy"
      />
    </SchemaWrapper>
  )
}

export default Image
